import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

// Design language shared with accordion-frontend (shop):
// Cormorant Garamond display serif, DM Sans body, Space Grotesk for
// uppercase letterspaced micro-labels; zinc-dark chrome, light catalog.
const config = defineConfig({
  globalCss: {
    body: {
      bg: "gray.50",
      color: "gray.800",
    },
  },
  theme: {
    tokens: {
      fonts: {
        heading: { value: `'Cormorant Garamond', Georgia, serif` },
        body: { value: `'DM Sans', system-ui, sans-serif` },
        space: { value: `'Space Grotesk', system-ui, sans-serif` },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
